import React, { useState } from 'react';
import { darken } from '@mui/system';

import { Point2D } from '@paragon/contract-library';
import { RenderOrder } from '@paragon/three-shared';

interface Props {
  readonly position: Point2D;
}

const COLOR = '#42e558';
const HOVER_COLOR = darken(COLOR, 0.35);

export function CalculatedWebJointVisual({ position }: Props) {
  const [hovered, setHovered] = useState(false);

  return (
    <mesh
      position={[position.x, position.y, 0]}
      renderOrder={RenderOrder.CalculatedWebJointVisual}
      onPointerOver={(event) => {
        setHovered(true);
        event.stopPropagation();
      }}
      onPointerOut={(event) => {
        setHovered(false);
        event.stopPropagation();
      }}
    >
      <sphereGeometry args={[1, 8, 8]} />
      <meshBasicMaterial
        color={hovered ? HOVER_COLOR : COLOR}
        transparent
        depthTest={false}
        depthWrite={false}
        opacity={1}
        toneMapped
      />
    </mesh>
  );
}
